export default "/images/vendor/@coreui/icons/svg/flag/cif-pw.svg?33a7604da00fd1bfd9231724688d2cb4";